import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import exportXlsx from "./utils/exportXlsx";
import exportPdf from "./utils/exportPdf";

const ReportExportBar = ({ data, columns, reportTitle, dateRange, companyName }) => {
  const { t } = useTranslation("translations");

  if (!data || data.length === 0) return null;

  return (
    <div className="reports__export-bar">
      <button
        className="reports__export-btn reports__export-btn--xlsx"
        onClick={() => exportXlsx(data, columns, reportTitle)}
      >
        <FontAwesomeIcon icon={faFileExcel} />
        <span>{t("reports.filters.exportXlsx")}</span>
      </button>
      <button
        className="reports__export-btn reports__export-btn--pdf"
        onClick={() => exportPdf(data, columns, reportTitle, dateRange, companyName)}
      >
        <FontAwesomeIcon icon={faFilePdf} />
        <span>{t("reports.filters.exportPdf")}</span>
      </button>
    </div>
  );
};

export default ReportExportBar;
